import { Close } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  styled,
} from '@mui/material';
import { IJob } from 'wisestep-api';
import {
  WsButton,
  WsColors,
  WsIconActiveJob,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import JobDetails from './JobDetails';

interface IJobPreviewScreenProps {
  visibility: boolean;
  onClose: () => void;
  onPublish: () => void;
  job: IJob;
}
const HeaderTheme = styled(Box)(() => ({
  padding: 1,
  backgroundColor: WsColors.TertiaryShades50,
  borderRadius: 4,
}));

const JobPreviewScreen = ({ visibility, onClose, job, onPublish }: IJobPreviewScreenProps) => {
  return (
    <Dialog open={visibility} onClose={onClose} maxWidth="lg" scroll="paper">
      <HeaderTheme>
        <Stack direction="row">
          <Grid item xs={6} container pt={1.5}>
            <Box pt={0.3} px={0.5}>
              <WsIconActiveJob />
            </Box>
            {job.title && (
              <Box pt={0.2}>
                <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                  {job.title}
                </WsTypography>
              </Box>
            )}
            {job.jobCode && (
              <Box pt={0.5} px={0.5}>
                <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
                  {job.jobCode}
                </WsTypography>
              </Box>
            )}
            {job.companyName && (
              <Box pt={0.2}>
                <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.PRIMARY}>
                  {` @ ${job.companyName}`}
                </WsTypography>
              </Box>
            )}
          </Grid>
          <Grid item xs={6} container justifyContent="flex-end">
            <Box mx={1}>
              <IconButton onClick={onClose} sx={{ p: 0, mt: 2 }}>
                <Close sx={{ color: WsColors.TertiaryShades500 }} />
              </IconButton>
            </Box>
          </Grid>
        </Stack>
      </HeaderTheme>
      <DialogContent dividers={true}>
        <JobDetails job={job} />
      </DialogContent>

      <DialogActions>
        <WsButton onClick={onPublish}>Publish</WsButton>
      </DialogActions>
    </Dialog>
  );
};
export default JobPreviewScreen;
